import React from 'react';
import errorLog from '../services/errorLog';
import { APP_VERSION } from '../constants/version';

/**
 * App-wide React error boundary. Catches render/runtime errors in the tree,
 * records them to the central error log (with the component stack as context),
 * and shows a recoverable fallback with an "Export error log" action.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: (error && error.message) || 'Unknown error' };
  }

  componentDidCatch(error, info) {
    errorLog.capture(error, 'react', {
      componentStack: info && info.componentStack ? info.componentStack : null,
    });
  }

  handleExport = () => {
    errorLog.export();
  };

  handleReload = () => {
    if (typeof window !== 'undefined') window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const wrap = {
      maxWidth: 560,
      margin: '48px auto',
      padding: 24,
      borderRadius: 12,
      border: '1px solid #e0b4b4',
      background: '#fff6f6',
      color: '#5a2a2a',
      fontFamily: 'system-ui, sans-serif',
    };
    const btn = {
      marginRight: 10,
      marginTop: 12,
      padding: '8px 14px',
      borderRadius: 8,
      border: '1px solid #c98a8a',
      background: '#fff',
      color: '#5a2a2a',
      cursor: 'pointer',
    };

    return (
      <div style={wrap} role="alert">
        <h2 style={{ marginTop: 0 }}>⚠️ Something went wrong</h2>
        <p>The app hit an unexpected error. It has been recorded in the error log.</p>
        <p style={{ fontFamily: 'ui-monospace, monospace', fontSize: 13, opacity: 0.85 }}>
          {this.state.message}
        </p>
        <div>
          <button style={btn} onClick={this.handleExport}>Export error log</button>
          <button style={btn} onClick={this.handleReload}>Reload</button>
        </div>
        <p style={{ fontSize: 12, opacity: 0.6, marginBottom: 0 }}>looper-midi-control v{APP_VERSION}</p>
      </div>
    );
  }
}
